import { render, staticRenderFns } from "./BCXExtendedDropdown.vue?vue&type=template&id=03526b7e&scoped=true"
import script from "./BCXExtendedDropdown.vue?vue&type=script&lang=ts"
export * from "./BCXExtendedDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BCXExtendedDropdown.vue?vue&type=style&index=0&id=03526b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03526b7e",
  null
  
)

export default component.exports